import {ConcelloService} from "concello/service";
import {EDARService, BombeoService, TanqueService} from "saneamiento/service";
import {AglomeracionService} from "saneamiento/aglomeracion/service";
import {ConexionService} from "conexion/service";

const DataVisualizationService = {
    getConcellos: (filter, page, sort, order, format = null) => ConcelloService.getPaginatedList(filter, page, sort, order, format),
    getEdars: (filter, page, sort, order, format = null) => EDARService.getPaginatedList(filter, page, sort, order, format),
    getAglomeracions: (filter, page, sort, order, format = null) => AglomeracionService.getPaginatedList(filter, page, sort, order, format),
    getConexiones: (filter, page, sort, order, format = null) => ConexionService.getPaginatedList(filter, page, sort, order, format),
    getBombeos: (filter, page, sort, order, format = null) => BombeoService.getPaginatedList(filter, page, sort, order, format),
    getTanques: (filter, page, sort, order, format = null) => TanqueService.getPaginatedList(filter, page, sort, order, format),
};

export default DataVisualizationService;

